import { createSelector } from "reselect";
import { RootState } from "../store";
import { UserState } from "./user.slice";

export const selectUserReducer = (state: RootState): UserState => state.user;

export const selectCurrentUser = createSelector(
  selectUserReducer,
  (user) => user.currentUser
);
export const selectIsProvider = createSelector(
  selectUserReducer,
  (user) => user.currentUser != null && user.currentUser.businessName != null
);

export const selectIsLoggedIn = createSelector(
  [selectUserReducer],
  (user) => user.isLoggedIn
);

export const selectCurrentCountry = createSelector(
  [selectUserReducer],
  (user) => user.currentCountry
);

export const selectIsLoading = createSelector(
  [selectUserReducer],
  (user) => user.isLoading
);

export const selectNotifications = createSelector(
  [selectUserReducer],
  (user) => user.notifications
);
